import React, { useState, useEffect, useMemo, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';

import DataTableUtils from '../../utilities/DataTableUtils';
import JobViewDialog from '../../pages/competition/JobViewDialog';
import { Button } from 'primereact/button';

const CompetitionJobListViewComponent = (props) => {
    const [jobs, setJobs] = useState([]);
    const [viewDialogVisible, setViewDialogVisible] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);

    const toast = useRef(null);
    const dt = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        const getJobs = async () => {
            await competitionService.getCompetitionJobs(props?.competition.id)
                .then((_jobs) => {
                    setJobs(_jobs);
                })
                .catch((error) => toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getJobs();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [competitionService, props]);

    const showViewDialog = (_job) => {
        setSelectedJob(_job);
        setViewDialogVisible(true);
    };

        const actionBodyTemplate = (rowData) => {
            return (
                <div className="actions flex flex-wrap align-items-center justify-content-end">
                    <Button
                        icon="pi pi-eye"
                        className="p-button-rounded p-button-primary m-1"
                        onClick={() => showViewDialog(rowData)}
                        tooltip={translatedMessage('generic.edit')}
                        tooltipOptions={{ position: 'top' }}
                    />
                </div>
            );
        };

    return (
        <>
            <div className='col-12 mt-3'>
                <h5>{translatedMessage('job.paragraphTitle')}</h5>
                <DataTable
                    ref={dt}
                    value={jobs}
                    dataKey="id"
                    paginator
                    rows={DataTableUtils.defalRowsPerPage()}
                    rowsPerPageOptions={DataTableUtils.rowsPerPageOptions()}
                    className="datatable-responsive pcn-datatable"
                    responsiveLayout="scroll"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate={"{first} - {last} " + translatedMessage('generic.of') + " {totalRecords}"}
                    emptyMessage={translatedMessage('generic.tableEmptyMessage')}
                    sortField="jobID"
                    sortOrder={1}
                >
                    <Column
                        field="institution.name"
                        header={translatedMessage('institution.institution')}
                        sortable
                        headerStyle={{ width: '20%', minWidth: '10rem' }}
                    />
                    <Column
                        field="departmentType"
                        header={translatedMessage('job.departmentType')}
                        sortable
                        headerStyle={{ width: '15%', minWidth: '10rem' }}
                    />
                    <Column
                        field="departmentName"
                        header={translatedMessage('job.departmentName')}
                        sortable
                        headerStyle={{ width: '15%', minWidth: '10rem' }}
                    />
                    <Column
                        field="position"
                        header={translatedMessage('job.position')}
                        sortable
                        headerStyle={{ width: '15%', minWidth: '10rem' }}
                    />
                    <Column
                        field="jobClass"
                        header={translatedMessage('job.jobClass')}
                        sortable
                        headerStyle={{ width: '10%', minWidth: '10rem' }}
                    />
                    <Column
                        field="level"
                        header={translatedMessage('job.level')}
                        sortable
                        headerStyle={{ width: '10%', minWidth: '10rem' }}
                    />
                    <Column
                        field="jobID"
                        header={translatedMessage('job.jobID')}
                        sortable
                        headerStyle={{ width: '10%', minWidth: '10rem' }}
                    />
                    <Column body={actionBodyTemplate} />
                </DataTable>
            </div>

            {viewDialogVisible &&
                <JobViewDialog
                    value={selectedJob}
                    visible={viewDialogVisible}
                    visibleSetter={() => setViewDialogVisible(false)}
                />
            }
        </>
    );
};

export default CompetitionJobListViewComponent;
